export const Chinese = {
  Features: "特点",
  Blog: "博客",
  Trade: "交易",
  trade: "交易",
  Buy: "购买/出售",
  Download: "下载",
  The: "The",
  gateway: "网关",
  To: "到",
  to: "到",
  the: "the",
  next: "下一个",
  generation: "一代",
  of: "的",
  Gamers: "玩家",
  Your: "您的",
  games: "游戏",
  coins: "硬币",
  All: "全部",
  in: "在",
  one: "一个",
  place: "地方",
  Simple: "简单",
  fun: "有趣",
  and: "和",
  And: "And",
  super: "超级",
  smart: "智能",
  Scan: "扫描",
  download: "下载",
  app: "应用程序",
  Available: "可用",
  on: "在",
  assets: "资产",
  Assets: "资产",
  Game: "游戏",
  game: "游戏",
  Connect: "连接",
  thirdparty: "第三方",
  Crypto: "加密",
  Card: "卡",
  Authentication: "认证",
  Own: "拥有",
  your: "您的",
  earn: "赚取",
  is: "是",
  Is: "是",
  easy: "容易",
  way: "方式",
  store: "存储",
  manage: "管理",
  winnings: "奖金",
  Whether: "无论是否",
  youre: "您是",
  Youre: "You're",
  competitive: "有竞争力的",
  gamer: "玩家",
  or: "或者",
  just: "只是",
  casual: "休闲的",
  player: "玩家",
  has: "有",
  something: "一些",
  for: "为",
  everyone: "每个人",
  effortlessly: "轻松",
  converts: "转换为",
  into: "进入",
  preferred: "首选",
  cryptocurrency: "加密货币",
  start: "开始",
  earning: "赚钱",
  Exclusive: "独家",
  content: "内容",
  experiences: "体验",
  now: "现在",
  at: "在",
  fingertips: "指尖",
  passport: "护照",
  unlock: "解锁",
  favourite: "最喜欢的",
  need: "需要",
  do: "做",
  connect: "连接",
  any: "任何",
  other: "其他",
  Gaming: "游戏",
  Platform: "平台",
  account: "帐户",
  Once: "一旦",
  connected: "连接",
  youll: "你将",
  Youll: "You'll",
  be: "是",
  able: "能够",
  rewards: "奖励",
  unlocking: "解锁",
  instantly: "立即",
  enjoying: "享受",
  powered: "由",
  will: "将",
  launch: "推出",
  token: "代币",
  listing: "上市",
  major: "主要",
  coming: "即将到来",
  soon: "很快",
  participate: "参与",
  our: "我们的",
  premium: "高级",
  collections: "收藏品",
  you: "您",
  You: "You",
  must: "必须",
  signup: "注册",
  get: "获取",
  verified: "验证",
  buy: "购买",
  using: "使用",
  respectively: "分别",
  Smartest: "最聪明的",
  Safe: "安全",
  Secure: "安全",
  Earn: "赚钱",
  Big: "大",
  Join: "加入",
  Trend: "趋势",
  Dont: "不要",
  left: "留下",
  behind: "在后面",
  Welcome: "欢迎",
  world: "世界",
  possibilities: "可能性",
  space: "空间",
  no: "没有",
  longer: "更长",
  thing: "事情",
  it: "它",
  present: "现在",
  Over: "结束",
  invested: "投资",
  projects: "项目",
  past: "过去",
  year: "年",
  free: "免费",
  easiest: "最容易的",
  anywhere: "任何地方",
  anytime: "随时",
  Use: "使用",
  accepted: "被接受",
  from: "来自",
  online: "在线",
  globally: "全球",
  With: "使用",
  an: "一个",
  instant: "瞬时",
  cash: "现金",
  conversions: "兑换",
  can: "可以",
  spend: "花费",
  without: "没有",
  hassles: "麻烦",
  top: "顶级",
  notch: "档次",
  security: "安全",
  blockchain: "区块链",
  backbone: "骨干",
  are: "是",
  always: "总是",
  safe: "安全",
  perfect: "完美",
  most: "最",
  out: "出",
  Rewarding: "有回报",
  complete: "完全",
  control: "控制",
  over: "在",
  funds: "资金",
  while: "同时",
  prioritizing: "优先考虑",
  gaming: "游戏",
  back: "回来",
  with: "与",
  every: "每一个",
  use: "使用",
  today: "今天",
  level: "水平",
  up: "提升",
  rules: "规则",
  only: "只有",
  keys: "键",
  so: "所以",
  Our: "我们的",
  audited: "经审计的",
  audit: "审计",
  firms: "公司",
  constantly: "不断",
  reviewed: "审查",
  ensure: "确保",
  maximum: "最大",
  Convenience: "方便",
  moment: "时刻",
  WAYS: "方法",
  AUTHENTICATION: "认证",
  TO: "TO",
  STRENGTHEN: "加强",
  YOUR: "您的",
  ASSETS: "资产",
  SAFETY: "安全",
  enjoy: "享受",
  all: "所有",
  this: "这个",
  amazing: "令人惊叹的",
  functionalities: "功能",
  A: "一个",
  Decentralized: "去中心化",
  wallet: "钱包",
  dedicated: "专用的",
  Home: "首页",
  Marketplace: "市场",
  Privacy: "隐私",
  Policy: "政策",
  Terms: "条款",
  Service: "服务",
  Navigation: "导航",
  Products: "产品",
  Legal: "法律",
  What: "什麼",
  How: "如何",
  blockchains: "区块链",
  does: "做",
  support: "支持",
  types: "類型",
  deposit: "訂金",
  withdraw: "提取",
  earned: "賺",
  my: "我的",
  I: "我",
};
